
function NotAuthorized() {
  return (
    <div className="div--not-authorized fade-in-up"><img src="/kitty_sign_in.png" alt="Login" width={150} height={150} />Login with your account to continue.</div>
  )
}

export default NotAuthorized